import { render, staticRenderFns } from "./worksfor.vue?vue&type=template&id=62b0be19&scoped=true&"
import script from "./worksfor.vue?vue&type=script&lang=js&"
export * from "./worksfor.vue?vue&type=script&lang=js&"
import style0 from "./worksfor.vue?vue&type=style&index=0&id=62b0be19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b0be19",
  null
  
)

export default component.exports